import React from 'react'
import { Modal } from 'antd'

import type { HookAPI } from 'antd/es/modal/useModal'
import type { NotificationInstance } from 'antd/lib/notification/interface'
import type { MessageInstance } from 'antd/lib/message/interface'

export interface AntdContextValue {
  customThemeInjected: boolean
  message: MessageInstance | null
  notification: NotificationInstance | null
  modalInstance: HookAPI | null
}

export const AntdContext = React.createContext<AntdContextValue>({
  customThemeInjected: false,
  message: null,
  notification: null,
  modalInstance: null,
})

export const AntdContextProvider = ({
  message,
  notification,
  children,
}: {
  message: MessageInstance
  notification: NotificationInstance
  children: React.ReactNode
}) => {
  const [modalInstance, modalContextHolder] = Modal.useModal()

  const antdContextValue = useMemo(() => {
    return {
      message,
      notification,
      modalInstance,
      customThemeInjected: true,
    }
  }, [message, modalInstance, notification])

  return (
    <AntdContext.Provider value={antdContextValue}>
      {children}
      {modalContextHolder}
    </AntdContext.Provider>
  )
}
